
export default {
    getDprOutputs: (state) => state.dprOutputs,
}